module.exports = __webpack_public_path__ + "static/media/Formular-Bold.b5428e15.woff2";